<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Danh sách tác vụ cá nhân</h3>
      </div>
    </div>
    <div class="card-body" v-loading="loading">
      <div class="grid-filter">
        <div class="display-flex-column">
          <span>Tác vụ</span>
          <el-input v-model="filters.taskId" clearable placeholder="Tìm theo mã tác vụ" style="width: 100%"
                    @change="handleSearch"/>
        </div>
        <div class="display-flex-column">
          <span>Đối tượng xử lý</span>
          <el-input v-model="filters.target" clearable placeholder="Tìm theo tên, số điện thoại KH"
                    style="width: 100%"
                    @change="handleSearch"/>
        </div>
        <div class="display-flex-column">
          <span>Loại tác vụ</span>
          <el-select v-model="filters.taskType" clearable multiple placeholder="Chọn loại tác vụ" style="width: 100%"
                     @change="handleSearch">
            <el-option
                v-for="item in typeExamOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
          </el-select>
        </div>
        <div class="display-flex-column">
          <span>Loại thi</span>
          <el-select v-model="filters.examType" filterable clearable placeholder="Chọn loại thi" @change="handleSearch">
            <el-option
                v-for="item in ExamType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="display-flex-column">
          <span>Trạng thái</span>
          <el-select v-model="filters.status" clearable placeholder="Chọn trạng thái" style="width: 100%"
                     @change="handleSearch">
            <el-option
                v-for="item in taskStatusOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
          </el-select>
        </div>
        <div class="display-flex-column">
          <span>Thời gian sinh tác vụ</span>
          <el-date-picker
              v-model="filters.createdAt"
              clearable
              end-placeholder="Đến ngày"
              format="dd/MM/yyyy"
              start-placeholder="Từ ngày"
              style="width: 100%"
              type="daterange"
              value-format="yyyy-MM-dd"
              @change="handleSearch"
          />
        </div>
        <div class="display-flex-column">
          <span>Thời hạn chấm bài</span>
          <el-date-picker
              v-model="filters.deadline"
              clearable
              end-placeholder="Đến ngày"
              format="dd/MM/yyyy"
              start-placeholder="Từ ngày"
              style="width: 100%"
              type="daterange"
              value-format="yyyy-MM-dd"
              @change="handleSearch"
          />
        </div>
      </div>
      <table class="table table-bordered">
        <thead class="thead-light">
        <tr>
          <th>Mã tác vụ</th>
          <th>Loại tác vụ</th>
          <th>Loại thi</th>
          <th>Đối tượng xử lý</th>
          <th>Trạng thái</th>
          <th>Thời gian sinh tác vụ</th>
          <th>Thời gian kết thúc</th>
          <th>Thời gian assign tác vụ</th>
          <th>Thời hạn chấm bài</th>
          <th class="text-center">Hành động</th>
        </tr>
        </thead>
        <tbody v-if="tasks.length === 0">
        <tr>
          <td class="text-center" colspan="10">Không có dữ liệu</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr v-for="task in tasks" :key="task.id">
          <td>{{ task.taskId }}</td>
          <td>
            <span :class="task.bgType" class="tag-custom">{{ task.taskType }}</span>
          </td>
          <td>{{task?.examTypelabel}}</td>
          <td>
            <span style="word-break: break-word">{{ task.target }}</span>
          </td>
          <td>
            <span :class="task.bgStatus" class="tag-custom">{{ task.status }}</span>
          </td>
          <td>{{ task.startDate }}</td>
          <td>{{ task.endDate }}</td>
          <td>{{ task.assignedAt }}</td>
          <td>{{ task.deadline }}</td>
          <td class="text-center">
            <router-link
                v-if="showMarkingMidtermTest(task)"
                :to="{ name: `mark-midterm-test`,
                            query: { classId: task.classroomId,name:task.studentName,previousPage:'PersonalTaskList',isEntrance: task.examTypelabel == 'Thi đầu khóa',academic_task_id: task.taskId },params: { id: task.markingExamRetakeId } }"
                class="btn btn-icon btn-xs btn-outline-primary"
                :title="'Chấm thi'"
            >
              <i :class="'el-icon-edit'"></i>
            </router-link>
             <router-link v-if="showViewMidtermTest(task)"
                :to="{
                  name: `view-midterm-test-result`,
                  query: { classId: task.classroomId, name: task.studentName, previousPage: 'PersonalTaskList',isEntrance: task.examTypelabel == 'Thi đầu khóa' }, params: { id: task.markingExamRetakeId }
                }"
                class="btn btn-icon btn-xs btn-outline-primary" :title="'Chấm thi'">
                <i :class="'el-icon-view'"></i>
              </router-link>

            <router-link
                v-if="task.showAction === MARK_GENERAL && +task.type !== 6"
                :to="{ name: `${task.statusNum === PENDING ? 'MarkExamStudent' : 'ViewExamStudent'}`,
                            query: { marking_retake_id: task.markingExamRetakeId, type: task.type, academic_task_id: task.taskId } }"
                class="btn btn-icon btn-xs btn-outline-primary"
                :title="task.statusNum === PENDING ? 'Chấm thi' : 'Xem kết quả chấm'"
            >
              <i :class="task.statusNum === PENDING ? 'el-icon-edit' : 'el-icon-view'"></i>
            </router-link>
            <router-link
                v-if="task.showAction === COI_THI"
                :to="{ name: 'AttendanceList', params: { id: task.markingExamShiftId }, query: {exam_form: task.examForm, isEntrance: task.examTypelabel == 'Thi đầu khóa'} }"
                class="btn btn-icon btn-xs btn-outline-info ml-2"
                title="Điểm danh">
              <i class="el-icon-date"/>
            </router-link>
            <el-button
                v-if="task.showAction === COI_THI"
                class="btn btn-icon btn-xs btn-outline-secondary ml-2"
                icon="el-icon-document-delete"
                title="Đánh dấu học viên gian lận"
                @click="openModalCheat(task)"
            />
            <!-- Tạm ẩn: vi phạm quy chế đã gộp vào popup đánh dấu gian lận.
            <el-button
                v-if="task.showAction === COI_THI && task.examTypelabel == 'Thi đầu khóa'"
                class="btn btn-icon btn-xs btn-outline-danger ml-2"
                icon="el-icon-document-remove"
                title="Vi phạm quy chế thi"
                @click="openModalViolation(task)"
            />
            -->
            <router-link
                v-if="task.showAction === COI_THI"
                :to="{ name: 'ImportSkillExam', params: { id: task.markingExamShiftId }, query: { isEntrance: task.examTypelabel == 'Thi đầu khóa' } }"
                class="btn btn-icon btn-xs btn-outline-primary ml-2"
                title="Import bài thi">
              <i class="el-icon-upload"/>
            </router-link>
          </td>
        </tr>
        </tbody>
      </table>
      <div style="display: flex; justify-content: center; align-items: center; height: 50px; position: relative">
        <paginate
            v-model="page"
            :page-count="lastPage"
            :page-range="3"
            :margin-pages="1"
            :click-handler="clickPage"
            :prev-text="'Trước'"
            :next-text="'Sau'"
            :container-class="'pagination b-pagination'"
            :pageLinkClass="'page-link'"
            :next-link-class="'next-link-item'"
            :prev-link-class="'prev-link-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-class="'page-item'"
        >
        </paginate>
        <div style="color: #0066FF; font-weight: 600; position: absolute; right: 0">Tổng số bản ghi: {{ total }}</div>
      </div>
    </div>
    <el-dialog :title="`Đánh dấu học viên gian lận ca thi ${taskSelected.target}`" :show-close="false" :visible.sync="isCheating"
               v-if="isCheating && !useNewViolationForm" width="60%">
      <hr style="padding: 0; margin-top: -20px"/>
      <HandleCheat @closeDialog="closeDialog"
                   :marking-exam-shift-id="taskSelected.markingExamShiftId"
                   :isEntrance="taskSelected.examTypelabel == 'Thi đầu khóa'"
                   :read-only="isPilotUser && isOldViolationData"
                   />
    </el-dialog>
    <el-dialog :title="`Đánh dấu học viên gian lận ca thi ${examName || taskSelected.target}`" :show-close="false" :visible.sync="isCheating"
               v-if="isCheating && useNewViolationForm" width="760px" top="1vh"
               custom-class="exam-violation-dialog" :close-on-click-modal="true" @close="closeDialog">
      <ExamViolation :marking-exam-shift-id="taskSelected.markingExamShiftId" :exam-form="taskSelected.examForm"
                     :is-entrance="taskSelected.examTypelabel == 'Thi đầu khóa'"
                     @closeDialog="closeDialog" @examName="getExamName" />
    </el-dialog>

    <!-- Modal vi phạm quy chế thi -->
    <el-dialog :title="`Đánh dấu học viên vi phạm quy chế ca thi ${taskSelected.target}`" :show-close="false" :visible.sync="isViolation"
               v-if="isViolation" width="60%">
      <hr style="padding: 0; margin-top: -20px"/>
      <ViolationRegulation @closeDialog="closeDialogViolation" @examName="getExamName"
                   :marking-exam-shift-id="taskSelected.markingExamShiftId"/>
    </el-dialog>
  </div>
</template>

<script>
import {COI_THI, HANDLE_CHEAT, MARK_GENERAL, PENDING, SUCCESS, TaskPersonalModel} from "../model/taskPersonal";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import HandleCheat from "./HandleCheat.vue";
import ExamViolation from "./ExamViolation.vue";
import ViolationRegulation from "./ViolationRegulation.vue";
import {taskStatusOption, typeExamOption} from "@/common/define";
import {GET_LIST_REASON_CHEAT, GET_LIST_TASK_EXAM} from "@/core/services/store/marking/marking.module";
import {ExamType, PILOT_EMPLOYEE_CODES} from "../../../../common/define";
import {mapGetters} from "vuex";


export default {
  name: 'PersonalTaskList',
  components: {HandleCheat, ExamViolation, ViolationRegulation},
  data() {
    return {
      loading: false,
      filters: {
        taskId: null,
        target: '',
        taskType: [],
        status: null,
        createdAt: [],
        deadline: [],
        examType: null
      },
      tasks: [],
      taskStatusOption,
      taskSelected: {},
      examName: '',
      loadingAttendance: true,
      typeExamOption,
      isCheating: false,
      useNewViolationForm: false,
      isOldViolationData: false,
      isViolation: false,
      page: 1,
      lastPage: 1,
      total: 0,
      PENDING,
      MARK_GENERAL,
      COI_THI,
      SUCCESS,
      HANDLE_CHEAT,
      ExamType
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    isPilotUser() {
      const userId = Number(this.currentUser?.user?.id)
      return Number.isFinite(userId) && PILOT_EMPLOYEE_CODES.includes(userId + 100000)
    }
  },
  methods: {
    showMarkingMidtermTest(task) {
      return task.statusNum === PENDING && +task.type === 6
    },
    showViewMidtermTest(task) {
      return (task.statusNum === SUCCESS || task.statusNum === HANDLE_CHEAT) && +task.type === 6
    },
    getPersonalTaskList() {
      this.getParams()
      this.callApi()
    },

    async handleSearch() {
      this.page = 1
      await this.queryFilterTaskList()
      this.getPersonalTaskList()
    },

    closeDialogViolation() {
      this.isViolation = false
      this.loadingAttendance = true
      this.examName = ''
    },

    closeDialog() {
      this.isCheating = false
      this.isOldViolationData = false
      this.loadingAttendance = true
      this.examName = ''
    },

    callApi() {
      this.loading = true
      const payload = {
        page: this.page,
        id: this.filters.taskId,
        user_info: this.filters.target,
        type: this.filters.taskType,
        status: this.filters.status,
        date_created: this.filters.createdAt,
        deadline: this.filters.deadline,
        exam_type: this.filters?.examType
      }
      this.$store.dispatch(GET_LIST_TASK_EXAM, payload).then(res => {
        if (!res.error) {
          const data = res.data
          this.page = res.pagination.current_page
          this.lastPage = res.pagination.last_page
          this.total = res.pagination.total
          this.tasks = data.map(item => {
            return new TaskPersonalModel(item)
          }) ?? []
          this.totalStudent = res.total
        }
      }).catch(e => {
        console.log(e, 'error exam')
      }).finally(() => {
        this.loading = false
      })
    },

    getParams() {
      const query = this.$route.query
      this.filters.taskId = query.taskId
      this.filters.target = query.target ?? null
      this.filters.status = query.status !== undefined && query.status !== null && query.status !== '' ? +query.status : null;
      this.filters.taskType = query.taskType ? JSON.parse(`[${query.taskType}]`) : []
      this.filters.createdAt = query.createdAt ?? null
      this.filters.deadline = query.deadline ?? null
      this.filters.examType = query.examType !== undefined && query.examType !== null && query.examType !== '' && !isNaN(+query.examType) ? +query.examType : null
    },

    async openModalCheat(task) {
      try {
        const res = await this.$store.dispatch(GET_LIST_REASON_CHEAT, {
          marking_exam_shift_id: task.markingExamShiftId
        })
        if (res.error) throw new Error(res.message)
        this.isOldViolationData = res.data?.is_old;
        this.useNewViolationForm = this.isPilotUser && !this.isOldViolationData
        this.taskSelected = task
        this.isCheating = true
      } catch (error) {
        this.$message.error(error.message || 'Không tải được thông tin hành vi vi phạm.')
      }
    },
    openModalViolation(task) {
      this.isViolation = true
      this.taskSelected = task
    },

    getExamName(value) {
      if (value) {
        this.loadingAttendance = false
        this.examName = value
      }
    },

    async queryFilterTaskList() {
      await this.$router.replace({
        name: 'PersonalTaskList',
        query: {
          taskId: this.filters.taskId || undefined,
          target: this.filters.target || undefined,
          status: this.filters.status ?? undefined,
          taskType: this.filters.taskType?.length ? this.filters.taskType : undefined,
          createdAt: this.filters.createdAt?.length ? this.filters.createdAt : undefined,
          deadline: this.filters.deadline?.length ? this.filters.deadline : undefined,
          examType: this.filters.examType ?? undefined,
        },
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    },

    clickPage(page) {
      this.page = page;
      this.getPersonalTaskList();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý tác vụ cá nhân", name: 'PersonalTaskList'},
      {title: "Coi thi - Chấm thi"}
    ]);
    this.getPersonalTaskList()
  }
}
</script>

<style scoped>
::v-deep .exam-violation-dialog { display: flex; flex-direction: column; max-height: 98vh; max-width: calc(100vw - 24px); border-radius: 18px; margin-bottom: 1vh; }
::v-deep .exam-violation-dialog .el-dialog__header { flex-shrink: 0; margin: 0 20px; padding: 14px 0 10px; border-bottom: 1px solid #e5e5e5; }
::v-deep .exam-violation-dialog .el-dialog__title { display: block; color: #151515; font-size: 19px; font-weight: 600; line-height: 26px; overflow-wrap: anywhere; }
::v-deep .exam-violation-dialog .el-dialog__body { box-sizing: border-box; min-height: 0; padding: 10px 20px 16px; overflow-y: auto; }
@media (max-width: 600px) {
  ::v-deep .exam-violation-dialog .el-dialog__header { margin: 0 16px; }
  ::v-deep .exam-violation-dialog .el-dialog__body { padding: 12px 16px 16px; }
}
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 20px;
}


.bg-teal-500 {
  background: #0349AC;
  color: white;
}

.bg-entrance-exam-general {
  background: #FF9393;
  color: white;
}

.bg-entrance-exam-speaking {
  background: #0978CD;
  color: white;
}

.bg-yellow-500 {
  background: #FF9900;
  color: black;
}

.bg-red-500 {
  background: #C40D0D;
  color: white;
}

.bg-success {
  background: #1BC5BD;
  color: white;
}

.bg-blue-500 {
  background: #0066FF;
  color: white;
}

.grid-filter {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 10px 60px;
}

.tag-custom {
  display: flex;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 5px;
}

@media screen and (max-width: 1560px) {
  .grid-filter {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px 30px;
  }
}

@media screen and (max-width: 1280px) {
  .grid-filter {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px 30px;
  }
}
</style>
